import React from 'react';
import { NavLink } from 'react-router-dom';
import { XIcon, HomeIcon, BookOpenIcon, BeakerIcon, PillIcon, HeartIcon, ZapIcon, StarIcon } from 'lucide-react';
interface SidebarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  open,
  setOpen
}) => {
  const navigation = [{
    name: 'Home',
    href: '/',
    icon: HomeIcon
  }, {
    name: 'NCCN Options',
    href: '/nccn-options',
    icon: BookOpenIcon
  }, {
    name: 'Clinical Trials',
    href: '/clinical-trials',
    icon: BeakerIcon
  }, {
    name: 'Off-guideline Drugs',
    href: '/off-guideline-drugs',
    icon: PillIcon
  }, {
    name: 'Whole Health',
    href: '/whole-health',
    icon: HeartIcon
  }, {
    name: 'Innovation',
    href: '/innovation',
    icon: ZapIcon
  }, {
    name: 'End of Life Care',
    href: '/end-of-life-care',
    icon: StarIcon
  }];
  return <>
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 flex z-40 lg:hidden ${open ? 'block' : 'hidden'}`} role="dialog" aria-modal="true" data-id="element-105">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true" onClick={() => setOpen(false)} data-id="element-106" />
        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white focus:outline-none" data-id="element-107">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-108">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setOpen(false)} data-id="element-109">
              <span className="sr-only" data-id="element-110">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-111" />
            </button>
          </div>
          <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto" data-id="element-112">
            <div className="flex-shrink-0 flex items-center px-4" data-id="element-113">
              <span className="text-xl font-bold" data-id="element-114">PCCN</span>
            </div>
            <nav className="mt-5 px-2 space-y-1" data-id="element-115">
              {navigation.map(item => <NavLink key={item.name} to={item.href} className={({
              isActive
            }) => `group flex items-center px-2 py-2 text-base font-medium rounded-md ${isActive ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-116">
                  <item.icon className="mr-4 h-6 w-6 text-gray-500" aria-hidden="true" data-id="element-117" />
                  {item.name}
                </NavLink>)}
            </nav>
          </div>
        </div>
      </div>
      {/* Desktop sidebar */}
      <div className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0" data-id="element-118">
        <div className="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white" data-id="element-119">
          <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" data-id="element-120">
            <div className="flex items-center flex-shrink-0 px-4" data-id="element-121">
              <span className="text-xl font-bold" data-id="element-122">PCCN</span>
            </div>
            <nav className="mt-5 flex-1 px-2 bg-white space-y-1" data-id="element-123">
              {navigation.map(item => <NavLink key={item.name} to={item.href} className={({
              isActive
            }) => `group flex items-center px-2 py-2 text-sm font-medium rounded-md ${isActive ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-124">
                  <item.icon className="mr-3 h-5 w-5 text-gray-500" aria-hidden="true" data-id="element-125" />
                  {item.name}
                </NavLink>)}
            </nav>
          </div>
        </div>
      </div>
    </>;
};
export default Sidebar;